var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { styled, theme } from "../theme";
import { Icon } from "../icon";
export var DropdownMenuButton = function (_a) {
    var open = _a.open, children = _a.children, rest = __rest(_a, ["open", "children"]);
    return (React.createElement(Wrapper, __assign({ className: rest.className }, rest),
        children,
        React.createElement(IconWrapper, null,
            React.createElement(Icon, { name: open ? "up" : "down", size: 12, color: theme.color.darkBlue100 }))));
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: inline-flex;\n  cursor: pointer;\n  user-select: none;\n"], ["\n  align-items: center;\n  display: inline-flex;\n  cursor: pointer;\n  user-select: none;\n"])));
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var templateObject_1, templateObject_2;
